import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function MobileMenu({ active }: { active: boolean }) {
    const { isAuthenticated, logout } = useAuth();

    return (
        <div className={
            `absolute top-0 right-0 w-[250px] h-full bg-[#333] border-l-4 border-primary z-50
            flex flex-col justify-center p-10 text-right
            transform transition-transform duration-300
            ${active ? "translate-x-0" : "translate-x-full"}`}
        >
            <Link className="text-primary text-lg my-4 hover:text-white transition" to="/leaderboard">گریت تیم</Link>
            <a className="text-primary text-lg my-4 hover:text-white transition" href="https://arahooshvira.com/aralink/Griteam/">درباره ما</a>
            <a className="text-primary text-lg my-4 hover:text-white transition" href="https://arahooshvira.com/aralink/Griteam/">تماس با ما</a>
            {isAuthenticated && <button onClick={() => logout()} className="text-primary text-lg my-4 hover:text-red-500 transition text-right"> خروج از حساب</button>}
        </div>
    );
}